module.exports = __webpack_public_path__ + "static/media/undraw_two_factor_authentication_namy.9045245b.svg";